/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";
import globals from "web/script/modules/globals";
import forms from "web/script/dom/forms";
import requester from "web/script/modules/requester";

const COLLECTION_FEED_HEADER_CLASS = "collection-feed-header-edit";
const COLLECTION_FEED_HEADER_DETAILS_FORM = `.${COLLECTION_FEED_HEADER_CLASS}__details-form`;
const SUBMIT_BUTTON_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__button--submit`;
const DELETE_BUTTON_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__delete-action`;
const DELETE_CONFIRMATION_BUTTON_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__delete-confirmation`;
const DELETE_ABORTION_BUTTON_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__delete-abortion`;

const HEADER_DELETE_OVERLAY_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__delete-overlay`;
const HEADER_DELETE_OVERLAY_SHOW_MODIFIER = `${COLLECTION_FEED_HEADER_CLASS}__delete-overlay--show`;
const HEADER_SAVE_OVERLAY_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__save-overlay`;
const HEADER_SAVE_OVERLAY_SHOW_MODIFIER = `${COLLECTION_FEED_HEADER_CLASS}__save-overlay--show`;
const HEADER_ERROR_OVERLAY_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__error-overlay`;
const HEADER_ERROR_OVERLAY_SHOW_MODIFIER = `${COLLECTION_FEED_HEADER_CLASS}__error-overlay--show`;
const HEADER_LOADING_OVERLAY_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__loading-overlay`;
const HEADER_LOADING_OVERLAY_SHOW_MODIFIER = `${COLLECTION_FEED_HEADER_CLASS}__loading-overlay--show`;

const IMAGE_UPLOAD_INPUT_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__image-input`;
const IMAGE_UPLOAD_FORM_SELECTOR = `.${COLLECTION_FEED_HEADER_CLASS}__image-form`;

const OVERLAY_TIMEOUT = 1000;

export default baustein.register("collection-feed-header-edit", {
    getInitialRenderContext() {
        return {
            collection_feed_header_edit: {
                form_action: "",
                image_form_action: "",
                collection_id: "",
                collection_title: "",
                collection_description: "",
                cover_image: "",
                owner_url: "",
                return_url: ""
            }
        };
    },

    setupEvents(add) {
        add("change", IMAGE_UPLOAD_INPUT_SELECTOR, this.onCoverImageChange);
        add("submit", COLLECTION_FEED_HEADER_DETAILS_FORM, this.onSubmit);
        add("click", DELETE_BUTTON_SELECTOR, this.onDeleteClick);
        add("click", DELETE_CONFIRMATION_BUTTON_SELECTOR, this.onDeleteConfirmation);
        add("click", DELETE_ABORTION_BUTTON_SELECTOR, this.onDeleteAbortion);
    },

    /**
     * Function called when a change event on the image upload field happens.
     */
    onCoverImageChange() {
        // TODO: Make this asynchronous.
        this.el.querySelector(IMAGE_UPLOAD_FORM_SELECTOR).submit();
    },

    /**
     * Disables the submit button and sends the serialized data to the collections endpoint.
     *
     * @params {Event}
     */
    onSubmit(event) {
        event.preventDefault();
        const submitButton = this.el.querySelector(SUBMIT_BUTTON_SELECTOR);
        if (submitButton) {
            submitButton.disabled = true;
        }
        this.showLoadingOverlay();

        const formElement = this.el.querySelector(COLLECTION_FEED_HEADER_DETAILS_FORM);
        const formData = forms.serialize(formElement);
        const endpoint = formElement.action;
        const options = {
            method: "POST",
            body: formData
        };

        requester(endpoint, options)
            .then(requester.toJSON)
            .then(responseData => {
                this.hideLoadingOverlay();
                if (responseData.success) {
                    this.onSaveSuccess();
                } else {
                    this.showErrorOverlay();
                }
            })
            .catch(e => {
                console.error("Something went wrong when trying to save the collection.", e);
                this.showErrorOverlay();
            });
    },

    /**
     * Shows a success overlay and then redirects the user to the non-edit
     * version of the collection after an arbitrary timeout.
     */
    onSaveSuccess() {
        const saveOverlay = this.el.querySelector(HEADER_SAVE_OVERLAY_SELECTOR);
        saveOverlay.classList.add(HEADER_SAVE_OVERLAY_SHOW_MODIFIER);

        setTimeout(() => {
            const returnUrl = this.el.querySelector('[name="return_url"]');
            globals.window.location = returnUrl.value;
        }, OVERLAY_TIMEOUT);
    },

    /**
     * Shows the delete confirmation overlay.
     *
     * @params {Event}
     */
    onDeleteClick(event) {
        event.preventDefault();

        const deleteOverlay = this.el.querySelector(HEADER_DELETE_OVERLAY_SELECTOR);
        deleteOverlay.classList.add(HEADER_DELETE_OVERLAY_SHOW_MODIFIER);
    },

    /**
     * Tries to delete the collection. If successfull, redirects to the users'
     * collection list. If not, shows an error overlay and reloads the page.
     *
     * @params {Event}
     */
    onDeleteConfirmation(event) {
        event.preventDefault();

        const request = requester(`/services/collections/${this.options.collectionId}/`, {
            method: "DELETE"
        });

        request
            .then(requester.toJSON)
            .then(response => {
                globals.window.location = response.data.redirect_url;
            })
            .catch(err => {
                console.error(err);
                this.showErrorOverlay();
            });
    },

    /**
     * Dismisses the delete confirmation overlay.
     */
    onDeleteAbortion(event) {
        event.preventDefault();

        const deleteOverlay = this.el.querySelector(HEADER_DELETE_OVERLAY_SELECTOR);
        deleteOverlay.classList.remove(HEADER_DELETE_OVERLAY_SHOW_MODIFIER);
    },

    /**
     * Shows an error overlay and refreshes the page after an arbitrary timeout.
     */
    showErrorOverlay() {
        const errorOverlay = this.el.querySelector(HEADER_ERROR_OVERLAY_SELECTOR);
        errorOverlay.classList.add(HEADER_ERROR_OVERLAY_SHOW_MODIFIER);

        setTimeout(() => {
            globals.window.location.reload();
        }, OVERLAY_TIMEOUT);
    },

    /**
     * Shows the loading overlay.
     */
    showLoadingOverlay() {
        const loadingOverlay = this.el.querySelector(HEADER_LOADING_OVERLAY_SELECTOR);
        loadingOverlay.classList.add(HEADER_LOADING_OVERLAY_SHOW_MODIFIER);
    },

    /**
     * Hides the loading overlay.
     */
    hideLoadingOverlay() {
        const loadingOverlay = this.el.querySelector(HEADER_LOADING_OVERLAY_SELECTOR);
        loadingOverlay.classList.remove(HEADER_LOADING_OVERLAY_SHOW_MODIFIER);
    }
});

